import getParent from '../selectors';

export const getBinomialAlpha = state => getParent(state).binomialAlpha;
